/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventcreatordescription2Inputs */

const en_eventcreatordescription2 = /** @type {(inputs: Eventcreatordescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simple event creation with just a few words.`)
};

const de_eventcreatordescription2 = /** @type {(inputs: Eventcreatordescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Event aus wenigen Worten.`)
};

/**
* | output |
* | --- |
* | "Simple event creation with just a few words." |
*
* @param {Eventcreatordescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventcreatordescription2 = /** @type {((inputs?: Eventcreatordescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventcreatordescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventcreatordescription2(inputs)
	return de_eventcreatordescription2(inputs)
});
export { eventcreatordescription2 as "eventCreatorDescription" }